var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25D0C5",
    d: "M45.724 8.907a2.2375 2.2375 0 11-4.475 0 2.2375 2.2375 0 014.475 0zm22.306 7.13a4.324 4.324 0 000 8.614 4.325 4.325 0 000-8.615zm0 11.637a7.346 7.346 0 11.017-14.692 7.346 7.346 0 01-.017 14.692zm-26.096-.234h3.139V13.03h-3.14v14.41zm-9.667-2.822a4.2745 4.2745 0 110-8.549 4.275 4.275 0 010 8.55zm.25-11.587a6.243 6.243 0 00-5.042 2.655V13.03H24.67v18.3h3.105v-5.795a6.145 6.145 0 004.725 2.138 7.096 7.096 0 007.03-7.33 7.062 7.062 0 00-7.013-7.313zM50.933 27.44h5.06l4.157-14.41h-3.206l-3.49 12.106-3.49-12.105h-3.172l4.141 14.409z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivo);
export default __webpack_public_path__ + "static/media/pivo.73de6f2f76386d2b264cb676c9befca6.svg";
export { ForwardRef as ReactComponent };